import { AREA_SIGNAL_STATISTICS, TAreaSignalStatistics, TAreaSignalStatisticsSliceState } from "../types/downloadTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../core/store";

const initialState: TAreaSignalStatisticsSliceState = {
    areaSignalStatisticsData: null,
    areaSignalStatisticsLoading: false,
    areaSignalStatisticsError: null,
};

const areaSignalStatisticsSlice = createSlice({
    name: AREA_SIGNAL_STATISTICS,
    initialState,
    reducers: {
        getAreaSignalStatisticsRequestAction: (state: TAreaSignalStatisticsSliceState, _: PayloadAction<{ lat: number; latTo: number; lon: number; lonTo: number }>) => {
            state.areaSignalStatisticsLoading = true;
            state.areaSignalStatisticsError = null;
            state.areaSignalStatisticsData = null;
        },
        getAreaSignalStatisticsSuccessAction: (state: TAreaSignalStatisticsSliceState, { payload: data }: PayloadAction<TAreaSignalStatistics>,
        ) => {
            state.areaSignalStatisticsLoading = false;
            state.areaSignalStatisticsData = data;
            state.areaSignalStatisticsError = null;
        },
        getAreaSignalStatisticsErrorAction: (state: TAreaSignalStatisticsSliceState, { payload: error }: PayloadAction<any>,
        ) => {
            state.areaSignalStatisticsLoading = false;
            state.areaSignalStatisticsData = null;
            state.areaSignalStatisticsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});


export const areaSignalStatisticsActions = {
    ...areaSignalStatisticsSlice.actions
};

export default areaSignalStatisticsSlice.reducer;

export const selectAreaSignalStatistics = (state: RootState) =>
    state.areaSignalStatisticsSlice.areaSignalStatisticsData;
export const selectAreaSignalStatisticsLoading = (state: RootState) =>
    state.areaSignalStatisticsSlice.areaSignalStatisticsLoading;
export const selectAreaSignalStatisticsError = (state: RootState) =>
    state.areaSignalStatisticsSlice.areaSignalStatisticsError;